 export const toFa = {
    "Sunny": "آفتابی",
    "Clear": "صاف",
    "Partly cloudy": "نیمه ابری",
    "Cloudy": "ابری",
    "Overcast": "افتاب پوشیده",
    "Mist": "مه",
    "Patchy rain possible": "بارش‌های پراکنده باران",
    "Patchy snow possible": "بارش‌های پراکنده برف",
    "Patchy sleet possible": "بارش‌های پراکنده برف و باران",
    "Patchy freezing drizzle possible": "باران نمناکی احتمالی",
    "Thundery outbreaks possible": "احتمال وقوع رعد و برق",
    "Blowing snow": "بارش برف و باد",
    "Blizzard": "بوران",
    "Fog": "مه",
    "Freezing fog": "مه برف",
    "Patchy light drizzle": "بارش خفیف باران",
    "Light drizzle": "بارش خفیف باران",
    "Freezing drizzle": "بارش برفی",
    "Heavy freezing drizzle": "بارش برفی سنگین",
    "Patchy light rain": "بارش‌های نور",
    "Light rain": "بارش باران",
    "Moderate rain at times": "بارش‌های معتدل احتمالی",
    "Moderate rain": "بارش معتدل",
    "Heavy rain at times": "بارش باران سنگین احتمالی",
    "Heavy rain": "بارش باران سنگین",
    "Light freezing rain": "بارش برف خفیف",
    "Moderate or heavy freezing rain": "بارش برف سنگین یا معتدل",
    "Light sleet": "بارش برفی خفیف",
    "Moderate or heavy sleet": "بارش برفی معتدل یا سنگین",
    "Patchy light snow": "بارش برف خفیف",
    "Light snow": "بارش برف خفیف",
    "Patchy moderate snow": "بارش معتدل برف",
    "Moderate snow": "بارش معتدل برف",
    "Patchy heavy snow": "بارش برفی خفیف",
    "Heavy snow": "بارش برف سنگین",
    "Ice pellets": "تگرگ",
    "Light rain shower": "بارش باران خفیف",
    "Moderate or heavy rain shower": "بارش باران معتدل یا سنگین",
    "Torrential rain shower": "بارش باران شدید",
    "Light sleet showers": "بارش برفی خفیف",
    "Moderate or heavy sleet showers": "بارش برفی معتدل یا سنگین",
    "Light snow showers": "بارش برف خفیف",
    "Moderate or heavy snow showers": "بارش برفی معتدل یا سنگین",
    "Light showers of ice pellets": "بارش تگرگ خفیف",
    "Moderate or heavy showers of ice pellets": "بارش تگرگ معتدل یا سنگین",
    "Patchy light rain with thunder": "بارش باران خفیف با رعد و برق",
    "Moderate or heavy rain with thunder": "بارش باران معتدل یا سنگین با رعد و برق",
    "Patchy light snow with thunder": "بارش برف خفیف با رعد و برق",
    "Moderate or heavy snow with thunder": "بارش برف معتدل یا سنگین با رعد و برق",
}
